import React from 'react';

const EditFieldButton = () => {
  return (
    <button
      className="mdc-button mdc-button--dense mdc-button-icon mdc-button-row pm-text-color--blue1 pm-display"
      data-mdc-auto-init="MDCRipple"
      data-test-class="edit-data-block-button"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.52148 5.8125L14.1016 9.17816"
          stroke="#2B67FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.77914 16.6018L8.16793 16.1978C8.9144 15.9803 9.56473 15.5157 10.0113 14.8803L15.3353 7.49771C15.9726 6.62327 15.7804 5.39876 14.906 4.76139L13.4614 3.70824C12.5871 3.07196 11.3615 3.26439 10.7251 4.13761L5.34262 11.6029C4.93187 12.1879 4.71484 12.8865 4.72082 13.6017L4.73417 15.0815C4.74426 16.1405 5.7625 16.8973 6.77914 16.6018Z"
          stroke="#2B67FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default EditFieldButton;
